import React, { useEffect } from "react";
import { propertiesStore } from "properties/_stores/propertiesStore";
import { LoadableFromLoading } from "_common/loaders/LoadableFromLoading";
import { FeaturedProperties } from "home/sections/FeaturedProperties";
import { PROPERTY_PURPOSE } from "properties/_models/PropertyMdl";

type Props = {
    purpose: PROPERTY_PURPOSE | "BOTH";
    pageBuilder?: boolean;
    carousel?: boolean;
    // undefined = limite par défaut du store ; FEATURED_PROPERTIES_ALL = pas de limite
    limit?: number;
    // n'affiche que le forfait EXCLUSIF, sans les placements "en vedette"
    exclusiveOnly?: boolean;
};

function FeaturedPropertiesSections({ purpose, pageBuilder, carousel, limit, exclusiveOnly }: Props) {
    // SSR : déclenche le fetch pendant le render serveur (le useEffect ne tourne pas côté serveur).
    // Le guard isLoading/isSucceeded du store évite tout double appel.
    if (!__BROWSER__) {
        propertiesStore.fetchFeaturedProperties(limit, purpose, exclusiveOnly);
    }
    useEffect(() => {
        propertiesStore.fetchFeaturedProperties(limit, purpose, exclusiveOnly);
    }, []);
    return (
        <>
            {propertiesStore.featuredPropertiesState?.[purpose] && (
                <LoadableFromLoading
                    loading={propertiesStore.featuredPropertiesState[purpose]}
                    noSpinner
                    noText
                    renderer={(_status, error) => {
                        if (
                            error ||
                            !propertiesStore.featuredProperties ||
                            !propertiesStore.featuredProperties[purpose].length
                        ) {
                            return null;
                        }
                        return (
                            <FeaturedProperties
                                properties={propertiesStore.featuredProperties[purpose]}
                                pageBuilder={pageBuilder}
                                carousel={carousel}
                            />
                        );
                    }}
                />
            )}
        </>
    );
}

export default FeaturedPropertiesSections;
